import { render, staticRenderFns } from "./Helplist.vue?vue&type=template&id=5d3568ba&"
import script from "./Helplist.vue?vue&type=script&lang=js&"
export * from "./Helplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports